import * as Yup from "yup";

export const requiredMessage = "This field is required.";

export const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required(requiredMessage)
    .min(8, "Must contain 8 or more characters")
    .matches(/[A-Z]/, "Must contain a capital letter")
    .matches(/[0-9]/, "Must contain a number")
    .matches(/[!@#$%^&*(),.?":{}|<>]/, "Must contain a special character"),
  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref("password"), null],
      "Your passwords don’t match. Please try again."
    )
    .required(requiredMessage)
});
